var map = {
	"./black/join.png": "xJDj",
	"./blue/join.png": "OJ6q",
	"./white/join.png": "qxVr"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "lJI+";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/join\.png$
// module id = lJI+
// module chunks = 24